define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var E911DetailsModel = /** @class */ (function () {
        function E911DetailsModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.PhoneNumberId = ko.observable();
            this.IsDefaultAddress = ko.observable(true);
            this.Uri = ko.observable();
            this.CallerName = ko.observable();
            this.AddressLine1 = ko.observable();
            this.AddressLine2 = ko.observable();
            this.Community = ko.observable();
            this.State = ko.observable();
            this.ZipCode = ko.observable();
            this.TelephoneNumber = ko.observable();
            this.LocationId = ko.observable();
            this.IsCustomerDefined = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, E911DetailsModel.Mapping, self);
            }
        }
        E911DetailsModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new E911DetailsModel(options.data);
            }
        };
        return E911DetailsModel;
    }());
    return E911DetailsModel;
});
//# sourceMappingURL=E911DetailsModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/E911DetailsModel.js
// module id = 78
// module chunks = 2